exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.board[data-v-3401c120] {\n  width: 100%;\n}\n.board-stage[data-v-3401c120] {\n  position: relative;\n  margin: 0 auto;\n}\ncanvas[data-v-3401c120] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  -ms-touch-action: none;\n      touch-action: none;\n}\n#board[data-v-3401c120] {\n  z-index: 1;\n}\n#piece[data-v-3401c120] {\n  z-index: 2;\n}\n#realtime[data-v-3401c120] {\n  z-index: 3;\n}\n#shot[data-v-3401c120] {\n  z-index: -1;\n  display: none;\n}\n", ""]);

// exports
